import React from 'react'
// import Header from '../Menpages/Header/Main'

import Header from '../Menhome/Header'
import Bredcom from '../MenTeam/Bredcom'
import Footer from '../Menhome/Footer'
import WebsiteDisclaimer from '../Menpages/Website-Disclaimer/main'


function Disclaimer() {
  return (
    <>
    <Header/>

    <Bredcom title={"Policies"} head={"Website Disclaimer"} sbtitle={"Website Disclaimer"}/>
    <div className='px-[20%]'>
    <WebsiteDisclaimer/>
    </div>
    <Footer/>
    </>
  )
}

export default Disclaimer